import { useEffect } from 'react';

const useAnimateOnScroll = () => {
    useEffect(() => {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -100px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.style.opacity = '0';
                    entry.target.style.transform = 'translateY(30px)';
                    setTimeout(() => {
                        entry.target.style.transition = 'all 0.8s ease';
                        entry.target.style.opacity = '1';
                        entry.target.style.transform = 'translateY(0)';
                    }, 100);
                    observer.unobserve(entry.target);
                }
            });
        }, observerOptions);

        // Observe elements for animation
        const elementsToObserve = document.querySelectorAll('.value-card, .module-card, .team-member, .section-header');
        elementsToObserve.forEach(el => {
            observer.observe(el);
        });

        // Cleanup function
        return () => {
            elementsToObserve.forEach(el => {
                observer.unobserve(el);
            });
        };
    }, []);
};

export default useAnimateOnScroll;